$(() => {
    new WOW().init();
});

